<template>
  <svg
    data-v-73b60f0e=""
    data-v-e74ee8bc=""
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    aria-label="search"
    role="img"
    class="c-icon"
  >
    <g data-v-73b60f0e="" fill="#63666A">
      <path
        d="M21.6404 20.3599L15.8204 14.5399C17.0474 12.9864 17.6342 11.0227 17.4609 9.05072C17.2876 7.07872 16.3671 5.24752 14.8879 3.93189C13.4088 2.61626 11.4827 1.91569 9.50395 1.97353C7.52519 2.03138 5.64335 2.84328 4.24356 4.24307C2.84377 5.64286 2.03187 7.5247 1.97402 9.50346C1.91617 11.4822 2.61675 13.4083 3.93238 14.8874C5.24801 16.3666 7.07921 17.2871 9.05121 17.4604C11.0232 17.6338 12.9869 17.0469 14.5404 15.8199L20.3604 21.6399C20.532 21.8061 20.7615 21.899 21.0004 21.899C21.2393 21.899 21.4688 21.8061 21.6404 21.6399C21.809 21.4695 21.9035 21.2396 21.9035 20.9999C21.9035 20.7603 21.809 20.5303 21.6404 20.3599ZM9.7404 15.6899C8.5636 15.6899 7.41323 15.341 6.43476 14.6872C5.45629 14.0334 4.69366 13.1041 4.24332 12.0169C3.79298 10.9297 3.67515 9.73331 3.90473 8.57913C4.13431 7.42494 4.701 6.36475 5.53312 5.53263C6.36524 4.70051 7.42543 4.13383 8.57962 3.90424C9.7338 3.67466 10.9302 3.79249 12.0174 4.24283C13.1046 4.69317 14.0339 5.4558 14.6876 6.43427C15.3414 7.41274 15.6904 8.56312 15.6904 9.73991C15.6773 11.3139 15.0463 12.8197 13.9333 13.9328C12.8202 15.0458 11.3144 15.6769 9.7404 15.6899Z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "box",
      required: true
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String
    },
    opt: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    icon() {
      if (!this.$icon || !this.$icon[this.name]) return {};
      return this.$icon[this.name];
    },
    option() {
      if (!this.opt) return {};
      return this.opt;
    },
    fill() {
      if (!this.icon || !this.icon.fill) return undefined;
      if (this.icon.fill == "#FFF") return this.icon.fill;
      if (!this.color) return this.icon.fill;
      return this.color;
    },
    stroke() {
      if (!this.icon || !this.icon.stroke) return undefined;
      if (this.icon.stroke == "#FFF") return this.icon.stroke;
      if (!this.color) return this.icon.stroke;
      return this.color;
    },
    viewBox() {
      if (!this.icon.viewBox) return "0 0 24 24";
      return this.icon.viewBox;
    }
  }
};
</script>

<style scoped></style>
